<template>
  <div class="form-line">
    <div class="form-field form-field-radio" >
        <label>Greeting Card</label>
        <div class="radio-option" v-if="campaign.notecard_text" style="opacity: 0.5">
          <input v-model="item.notecard_type" type="radio" value="default" disabled>
          <span class="radio-label">Attach default greeting card <i>(Charges apply)</i></span>
        </div>

        <div class="radio-option" v-if="!campaign.notecard_text">
          <input v-model="item.notecard_type" type="radio" value="none">
          <span class="radio-label">Send without greeting card</span>
        </div>

        <div class="radio-option" style="opacity: 0.5">
          <input v-model="item.notecard_type" type="radio" value="custom" disabled>
          <span class="radio-label">Use custom greeting card <i>(Charges apply)</i></span>
        </div>

        <div class="radio-option" v-if="campaign.notecard_text">
          <input v-model="item.notecard_type" type="radio" value="none">
          <span class="radio-label">Send without greeting card</span>
        </div>

        <div class="small-note">
            Unfortunately we're not able to include notecards with orders at the moment. We expect to be able to offer the service again in March 2025.
        </div>
    </div>

    <div v-if="item.notecard_type==='custom'" class="form-field">
        <label>Notecard Text</label>
        <textarea v-model="item.notecard_text" placeholder="Write your custom notecard text here." rows="6" :maxlength="option.notecard_format=='portrait'?240:1015"></textarea>
        <small class="notecard-price"><b>Greeting card price:</b> £1.00 per package <i>(Excluding VAT)</i></small>
        <small v-if="option.notecard_format=='portrait'" class="notecard-price">The Classic Hamper Co. notecards are limited 240 characters.</small>
        
    </div>
    
    <div v-if="item.notecard_type==='custom' && formType=='create'" id="field-notecard-preview" class="notecard-preview-component form-field" :class="option.notecard_format">
      <label>Notecard Preview</label>
      <div v-if="option.notecard_url || team.notecard_url" id="notecard-rotator" :class="previewSide">
        <div class="notecard-rotate front" @click="flip('front')">Front Side</div>
        <div class="notecard-rotate back" @click="flip('back')">Back Side</div>
      </div>
      <div id="notecard-preview" :side="previewSide">
        <div v-if="previewSide=='front'" class="notecard-preview-side" id="notecard-front-side">
          <div class="notecard-preview-text">{{ item.notecard_text }}</div>
        </div>
        <div v-if="previewSide=='back'" class="notecard-preview-side" id="notecard-back-side" :style="'background-image: url('+notecardBackground+')'"></div>
      </div>
    </div>
    
  </div>
</template>

<script>

export default {
    name: "FieldNotecard",
    props: { 
        item: Object,
        campaign: Object,
        formType: String,
        option: {
            type: Object,
            default: {notecard_format: 'landscape', notecard_url: null}
        }
    },
    data() {
        return {
            previewSide: 'front'
        }
    },
    mounted() {

    },
    methods: {
        flip(side) {
          this.previewSide = side;
        },
    },
    computed: {
        team() {
			return this.$store.state.team.detail;
		},
        notecardBackground() {
            if (this.option.notecard_url) return this.option.notecard_url;
            else return this.team.notecard_url;
        }
    },
    watch: {
        'item.notecard_text': {
            handler (text) {
                // NOTE: this.clearEmojis() doesn't exist, commented out because it was breaking down js
                //this.item.notecard_text = this.clearEmojis(text); 
            },
        },
    },
}
</script>